import React from 'react';
import './Education.css';

const Education = () => {
  const educationData = [
    {
      year: '2023 - 2026',
      degree: 'Associate’s Degree, Computer and Information Science',
      institution: 'Academia Institute of Technology',
      description: 'Pearson BTEC Higher National Diploma (HND).'
    },
    {
      year: 'July 2025 - August 2025',
      degree: 'Pontifícia Universidade Católica do Rio de Janeiro',
      institution: 'Scholarship Awarded',
      description: 'Erasmus+ exchange. Completed a research essay linking Brazilian social issues with technology-based solutions, combining cultural understanding with a computer science perspective.',
      link: 'https://www.academia.si/en/erasmus-plus-en/academia-students-participating-in-the-brazilian-seminars-exchange-program-at-puc-rio-university-in-brazil'
    },
    {
      year: 'June 2025',
      degree: 'Webster University Vienna Campus',
      institution: 'Scholarship Awarded',
      description: 'Erasmus+ mobility. Worked on a simulation project using custom software to manage a fictional social media platform, covering content moderation, social media, and realtime monitoring.'
    },
    {
      year: '2026 - 2027',
      degree: 'Bachelor’s Degree, Computer and Information Science',
      institution: 'University of Derby',
      description: 'Planned: Top-Up Bachelor (BSc Hons) at University of Derby after graduation.'
    }
  ];

  return (
    <section className="education" id="education">
      <div className="education-container">
        <div className="section-header">
          <h2 className="section-title pink-bg">EDUCATION</h2>
        </div>

        <div className="education-timeline">
          {educationData.map((item, index) => (
            <div key={index} className="education-item">
              <div className="education-year">{item.year}</div>
              <div className="education-content">
                <h3 className="education-degree">{item.degree}</h3>
                <h4 className="education-institution">{item.institution}</h4>
                <p className="education-description">{item.description}</p>

                {item.link && (
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="cv-download-btn">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                        <polyline points="15 3 21 3 21 9"/>
                          <line x1="10" y1="14" x2="21" y2="3"/>
                    </svg>
                      Featured on Academia
                  </a>
                )}

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;